export default __webpack_public_path__ + "static/media/procesos_innovacion.4f3faa42.png";